import React, {FC, useCallback, useState} from 'react';

import {cn} from '@bem-react/classname';
import {DatePicker} from '@gravity-ui/date-components';
import {DateTime, dateTimeParse} from '@gravity-ui/date-utils';
import i18n from 'ui/i18n';
import isDateRange from 'ui/utils/isDateRange';

import {RangeDatePickerProps} from './RangeDatePicker.types';

import './RangeDatePicker.scss';

const cnRangeDatePicker = cn('RangeDatePicker');

const RangeDatePicker: FC<RangeDatePickerProps> = ({fieldValue, onUpdateField, ...props}) => {
    const [begin, setBegin] = useState(() => {
        if (fieldValue?.begin) {
            return dateTimeParse(fieldValue?.begin) || null;
        }
        return null;
    });

    const [end, setEnd] = useState(() => {
        if (fieldValue?.end) {
            return dateTimeParse(fieldValue?.end) || null;
        }
        return null;
    });

    const onUpdateRangeBegin = useCallback(
        (value: DateTime | null) => {
            if (onUpdateField) {
                if (!value && !fieldValue?.end) {
                    onUpdateField(null);
                } else {
                    onUpdateField({
                        begin: value?.format('YYYY-MM-DD') || '',
                        end: isDateRange(fieldValue) ? fieldValue.end : '',
                    });
                }
            }
            setBegin(value);
        },
        [fieldValue, onUpdateField],
    );

    const onUpdateRangeEnd = useCallback(
        (value: DateTime | null) => {
            if (onUpdateField) {
                if (!value && !fieldValue?.begin) {
                    onUpdateField(null);
                } else {
                    onUpdateField({
                        begin: isDateRange(fieldValue) ? fieldValue.begin : '',
                        end: value?.format('YYYY-MM-DD') || '',
                    });
                }
            }
            setEnd(value);
        },
        [fieldValue, onUpdateField],
    );

    return (
        <div className={cnRangeDatePicker()}>
            <DatePicker
                {...props}
                value={begin}
                placeholder={i18n('survey-page', 'range-date-from')}
                onUpdate={onUpdateRangeBegin}
                maxValue={end || props.maxValue}
            />
            <DatePicker
                {...props}
                value={end}
                placeholder={i18n('survey-page', 'range-date-to')}
                onUpdate={onUpdateRangeEnd}
                minValue={begin || props.minValue}
            />
        </div>
    );
};
export default RangeDatePicker;
